/** Only the latest navigation intent may move focus after virtual rows mount. */
export function createRecordTableFocusScheduler(
  request: (callback: () => void) => number,
  cancelFrame: (id: number) => void,
) {
  let frame: number | null = null;
  let generation = 0;
  function cancel() {
    generation += 1;
    if (frame !== null) cancelFrame(frame);
    frame = null;
  }
  function schedule(focus: () => void) {
    cancel();
    const intent = generation;
    frame = request(() => {
      if (intent !== generation) return;
      frame = request(() => {
        if (intent !== generation) return;
        frame = null;
        focus();
      });
    });
  }
  return { cancel, schedule };
}
